"use client";

import useWindowSize from "@/hooks/useWindowSize";
import styles from "./MediaBackground.module.scss";
import { Modul_Text_mit_Bildhintergrund } from "@aleksundshantu/gp-types/acf-module";
import { Options_Modul_Text_mit_Bildhintergrund } from "@aleksundshantu/gp-types/acf-module-options";
type MediaBackgroundOverlayClientProps = {
  type: Options_Modul_Text_mit_Bildhintergrund["type"];
  gradient: Options_Modul_Text_mit_Bildhintergrund["gradient"];

  row_direction_class_mobile: Modul_Text_mit_Bildhintergrund["layout"]["row_direction_class_mobile"];
};

export const MediaBackgroundOverlayClient = ({
  type,
  row_direction_class_mobile,
  gradient,
}: MediaBackgroundOverlayClientProps) => {
  const { width } = useWindowSize();
  const isDesktop = width > 1024;
  return (
    ((type === "full-overlay" && isDesktop) ||
      (row_direction_class_mobile === "is-overlay" && !isDesktop)) && (
      <div
        className={`${styles.overlay}`}
        style={{
          background: gradient ? `${gradient}` : "transparent",
        }}
      ></div>
    )
  );
};
